<template>
    <div v-if="item && hidePrice == false" class="product-action component-actions align-items-start" >

        <Fragment
            v-if="!item.price_on_request && !isProductUnavailable"
        >
        <div class="w-100">
            <template v-if="item.availability > 0">
                <div class="col-md-8 p-0 mb-1">
                    <strong>Disponibilidade:</strong> {{ item.availability }} dias úteis.
                </div>
            </template>
            <c-input-qtd class="input-quantity">
                <button
                    class="btn-quantity-minus"
                    @click="setQuantityMinus()"
                    aria-label="Diminuir quantidade"
                >
                    <i class="fas fa-minus"></i>
                </button>
                <label><input type="text" :value="quantity" @blur="onBlurMinimumQuantity($event.target.value)"></label>
                <button
                    class="btn-quantity-plus"
                    @click="setQuantityPlus()"
                    aria-label="Aumentar quantidade"
                >
                    <i class="fas fa-plus"></i>
                </button>
            </c-input-qtd>
        </div>
            <div style="display: flex; flex-wrap: wrap">
                <c-ancora
                    v-if="activateProductCustomization && isProductCustomization"
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    :fontSize="$root.$children[0].theme.font_size_button"
                    href="#"
                    @click.prevent.stop="modalProductPersonalization"
                    class="paction mr-2"
                >
                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; min-width: 17.3rem; font-size:'+$root.$children[0].theme.font_size_button">Personalize seu produto</span>
                </c-ancora>
                <c-ancora
                    v-if="flavors.length"
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    :fontSize="$root.$children[0].theme.font_size_button"
                    href="#flavors"
                    class="paction mr-2"
                >
                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; min-width: 10rem; font-size:'+$root.$children[0].theme.font_size_button">Sabores</span>
                </c-ancora>
            </div>
            <div style="display: flex; flex-wrap: wrap">
                <c-ancora
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    :fontSize="$root.$children[0].theme.font_size_button"
                    href="#"
                    @click.prevent.stop="addCart()"
                    class="paction add-cart mr-2"
                >
                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; min-width: 15rem; font-size:'+$root.$children[0].theme.font_size_button">
                        {{ company.finalizacao_pagamento.tipo == 'PAGAMENTO' ? (isBudgetLayout ? 'Adicionar ao Orçamento' : 'Adicionar ao Carrinho') : 'Orçamento' }}
                    </span>
                </c-ancora>
                <c-ancora
                    v-if="purchaseButtonProductPage"
                    :backgroundColor="$root.$children[0].theme.products.button.background_color"
                    :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
                    :color="$root.$children[0].theme.products.button.color"
                    :colorHover="$root.$children[0].theme.products.button.color_hover"
                    :borderColor="$root.$children[0].theme.products.button.border_color"
                    :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
                    :borderRadius="$root.$children[0].theme.products.button.border_radius"
                    :textTransform="$root.$children[0].theme.products.button.text_transform"
                    href="#"
                    :fontSize="$root.$children[0].theme.font_size_button"
                    @click.prevent.stop="addCart(true)"
                    class="paction purchase mr-2"
                >
                    <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">
                        {{ company.finalizacao_pagamento.tipo == 'PAGAMENTO' ? (isBudgetLayout ? 'Orçar' : 'Comprar') : 'Orçamento' }}
                    </span>
                </c-ancora>
            </div>
        </Fragment>
        <c-ancora
            v-if="buttonWhatsapp && !item.price_on_request && !isProductUnavailable"
            backgroundColor="#fff"
            :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
            :color="$root.$children[0].theme.products.button_whatsapp.color"
            :colorHover="$root.$children[0].theme.products.button.color_hover"
            :borderColor="$root.$children[0].theme.products.button.border_color"
            :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
            :borderRadius="$root.$children[0].theme.products.button.border_radius"
            :textTransform="$root.$children[0].theme.products.button.text_transform"
            :fontSize="$root.$children[0].theme.font_size_button"
            :padding="$root.$children[0].theme.products.button_whatsapp.padding"
            @click.prevent="consultaWhatsapp()"
            href="#"
            class="paction mr-2"
        >
            <i title="Whatsapp" class="fab fa-whatsapp" style="font-size: 20px;"></i>
            <span :style="'font-weight: 500'" >Comprar pelo Whatsapp</span>
        </c-ancora>
        <c-button
            v-if="item.price_on_request"
            :href="textWhatsapp"
            :backgroundColor="$root.$children[0].theme.products.button.background_color"
            :backgroundColorHover="$root.$children[0].theme.products.button.background_color_hover"
            :color="$root.$children[0].theme.products.button.color"
            :colorHover="$root.$children[0].theme.products.button.color_hover"
            :borderColor="$root.$children[0].theme.products.button.border_color"
            :borderColorHover="$root.$children[0].theme.products.button.border_color_hover"
            :borderRadius="$root.$children[0].theme.products.button.border_radius"
            margin="0px 3rem 1rem 0px"
            textTransform="uppercase"
            height="unset"
            minWidth="124px"
            padding="1rem 2rem"
            display="inline-block"
            textAlign="center"
            lineHeight="1.5"
            letterSpacing="unset"
            transition="all .3s"
            @click.prevent="consultaWhatsapp()"
        >
            <span :style="'text-transform:'+$root.$children[0].theme.products.button.text_transform+'; font-size:'+$root.$children[0].theme.font_size_button">Consulte o preço</span>
        </c-button>
        <!-- <span
            style="margin-right:10px"
            v-if="
                (item.pro_stock_site < 1 || item.minimum_sale_quantity > item.pro_stock_site) &&
                item.out_of_stock_unavailable &&
                item.sell_out_of_stock == false &&
                !item.price_on_request &&
                company.finalizacao_pagamento.tipo == 'PAGAMENTO'
            "
        >
            Produto <strong style="color:tomato">Indisponível</strong>
        </span> -->
        <template v-if="isProductUnavailable">
            <ProductUnavailable />
        </template>

        <ProductTellMeWhenYouArrive
            v-if="isProductUnavailable"
            margin="0 0.6rem 1rem 0"
        />

        <a
            v-if="company.finalizacao_pagamento.tipo == 'PAGAMENTO'"
            href="#" class="checked"
            style="font-size:28px"
            @click.prevent.stop="saveWishList(bkpProduct.wish)"
            aria-label="Adicionar a lista de desejos"
        >
            <i
                v-if="bkpProduct.wish == true"
                class="fas fa-heart"
                style="opacity: 1"
            >
            </i>
            <i v-else class="far fa-heart"></i>
        </a>
    </div>
    <!-- <div class="product-single-share">
        <label>Share:</label>
        www.addthis.com share plugin
        <div class="addthis_inline_share_toolbox"></div>
    </div> -->
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { CAncora } from '../Styles/Button/styled'
import { Fragment } from 'vue-fragment'
import { CButton } from '../Styles/Button/styled'
import { CInputQtd } from '../Styles/Template/styled'
import ProductTellMeWhenYouArrive from './ProductTellMeWhenYoyArrive'
import ProductUnavailable from './ProductUnavailable'
import { swall } from '../../services/sweetAlert'

export default {
    name: 'ProductActions',
    components: {
        'c-button': CButton,
        'c-ancora': CAncora,
        'c-input-qtd': CInputQtd,
        ProductTellMeWhenYouArrive,
        ProductUnavailable,
        Fragment
    },
    props: {
        local: {
            default: 'modal'
        },
        item: {
            required: true
        },
        isProductCustomization: {
            default: false,
        },
        activateProductCustomization: {
            default: false,
        },
    },
    data() {
        return {
            company: this.$root.$children[0].$attrs.company,
            // quantity: 1
        }
    },
    methods: {
        ...mapActions("products", [
            "ActionSetItemWish",
            "setNumberOfBoxesSelected",
            "setQuantity",
            "setAvailability"
        ]),
        ...mapActions("clients", [
            "ActionSetEmailRegister"
        ]),
        ...mapActions("wishlist", [
            "ActionInsertItemWishList"
        ]),
        modalProductPersonalization() {
            this.$emit("showModalProductCustomization");
        },
        setQuantityMinus() {
            if(this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX') {
                let quantityWithClosedBox = this.quantity <= 1 ? 1 : this.quantity - 1
                if(quantityWithClosedBox < Number(this.minimumQuantity)) {
                    this.setQuantity(Number(this.minimumQuantity))
                    swall(`Este produto possui quantidade mínima de ${this.minimumQuantity} caixas.`)
                    return
                }
                this.setQuantity(quantityWithClosedBox)
                return
            }
            if(Number(this.quantity) < 2 || Number(this.quantity) <= Number(this.minimumQuantity)) {
                swall(`Este produto possui quantidade mínima de ${this.minimumQuantity} ${this.item.pro_sigla_medida}`)
                this.setQuantity(Number(this.minimumQuantity))
                return
            }
            let resto = Number(this.quantity) % Number(this.item.quantity_conversion_factor)
            let qtdSobra = resto == 0 ? Number(this.item.quantity_conversion_factor) - resto : resto
            let qtd = Number(this.quantity) - qtdSobra
            this.setQuantity(qtd < Number(this.minimumQuantity) ? Number(this.minimumQuantity) : qtd)
        },
        setQuantityPlus() {
            let max = this.item?.maximum_sale_quantity
            if(this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX') {
                if(this.item.sell_out_of_stock) {
                    if(max && this.quantity >= Math.trunc(max / this.item.quantity_per_box)) {
                        swall(`Quantidade máxima atingida para este produto.`)
                        return
                    }
                    this.setQuantity(this.quantity + 1)
                    return
                } else {
                    let maxQuantity = [
                        Math.trunc(this.item.pro_stock_site / this.item.quantity_per_box),
                        Math.trunc((max ?? this.item.pro_stock_site) / this.item.quantity_per_box)
                    ]
                    if(this.quantity >= Math.min(...maxQuantity)) {
                        swall(`Quantidade máxima atingida para este produto.`)
                        return
                    }
                    this.setQuantity(this.quantity + 1)
                }
                return
            }
            if(max && Number(this.quantity) >= Number(max)) {
                swall(`Quantidade máxima atingida para este produto.`)
                return
            }
            let resto = Number(this.quantity) % Number(this.item.quantity_conversion_factor)
            let qtdFalta = Number(this.item.quantity_conversion_factor) - resto

            if(max && (qtdFalta + Number(this.quantity)) > Number(max)) {
                swall(`Quantidade máxima atingida para este produto.`)
                return
            }
            this.setQuantity(qtdFalta + Number(this.quantity))
        },
        addCart(redirect_cart = false) {
            let data = {
                quantity: this.quantity,
                redirect_cart: redirect_cart
            }
            this.$emit('addCart', data)
            this.setQuantity(this.minimumQuantity)
        },
        async saveWishList(wish) {
            wish = !wish
            try {
                this.bkpProduct.wish = wish
                this.ActionSetItemWish({id: this.bkpProduct.id, wish: wish})
                await this.ActionInsertItemWishList({product_id: this.bkpProduct.id})
                if(this.facebookPixel?.settings?.AddToWishlist == true && this.bkpProduct.wish == true) {
                    fbq('track', 'AddToWishlist');
                }
                if(this.googleAds?.id != null) {
                    gtag('event', 'add_to_wishlist', {
                        'pageTitle': this.company.nome_fantasia,
                        'pageCategory': 'Produto',
                        'ecommerce': {
                            'currency': 'BRL',
                            'value': this.item.pro_price_site,
                            'products': [{
                                'id' : this.item.api_cod_original,
                                'name': this.item.pro_name_site,
                                'price': this.item.pro_price_site,
                                'brand': this.item.brand_name,
                            }],
                        }
                    });
                }
            } catch(error) {
                this.ActionSetItemWish({id: this.bkpProduct.id, wish: !wish})
                this.bkpProduct.wish = !wish
                if(error.status === 401) {
                    this.ActionSetEmailRegister(null)
                    this.$root.showModalApp('login_modal')
                    return
                }
                if(!error.data) {
                    alert(error)
                    return
                }
                let { data={} } = error.data
                if(data.msg) {
                    alert(msg)
                }
            }
        },
        consultaWhatsapp() {
            if(!this.textWhatsapp) {
                return
            }
            window.open(this.textWhatsapp, '_blank');
        },
        onBlurMinimumQuantity(eventQuantity) {
            this.setQuantity(eventQuantity)
            let max = this.item?.maximum_sale_quantity
            if(this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX') {
                if(Number(this.quantity) < Number(this.minimumQuantity)) {
                    this.setQuantity(Number(this.minimumQuantity))
                    let unitAbbreviation = this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX' ?
                        (this.minimumQuantity > 1 ? 'caixas' : 'caixa') : ''
                    swall(`Este produto possui quantidade mínima de ${this.minimumQuantity} ${unitAbbreviation}`)
                    return
                }
                if(max && this.quantity >= Math.trunc(max / this.item.quantity_per_box)) {
                    swall(`Quantidade máxima atingida para este produto.`)
                    this.setQuantity(Math.trunc(max / this.item.quantity_per_box))
                    return
                }
                if(!this.item.sell_out_of_stock) {
                    let maxQuantity = [
                        Math.trunc(this.item.pro_stock_site / this.item.quantity_per_box),
                        Math.trunc((max ?? this.item.pro_stock_site) / this.item.quantity_per_box)
                    ]

                    if(this.quantity > Math.min(...maxQuantity)) {
                        swall(`Quantidade máxima atingida para este produto.`)
                        this.setQuantity(Math.min(...maxQuantity))
                        return
                    }
                }
                return
            }
            if(Number(this.quantity) < Number(this.minimumQuantity)) {
                swall(`Este produto possui quantidade mínima de ${this.minimumQuantity} ${this.item.pro_sigla_medida}`)
                this.setQuantity(Number(this.minimumQuantity))
                return
            }
            let resto = Number(this.quantity) % Number(this.item.quantity_conversion_factor)
            let qtdFalta = Number(this.item.quantity_conversion_factor) - resto
            let qtdSobra = resto == 0 ? Number(this.item.quantity_conversion_factor) - resto : resto

            if(max && Number(this.quantity) >= max) {
                if(Number(this.quantity) > max) {
                    swall(`Este produto possui quantidade máxima de ${max} ${this.item.pro_sigla_medida}`)
                    this.setQuantity(this.quantity - Number(qtdSobra))
                    return
                }
                if(qtdSobra != Number(this.item.quantity_conversion_factor)) {
                    swall(`Quantidade máxima atingida.`)
                    this.setQuantity(this.quantity - Number(qtdSobra))
                    return
                }
                return
            }

            if(resto != 0) {
                if(qtdFalta <= qtdSobra) {
                    let qtd = qtdFalta + Number(this.quantity)
                    this.setQuantity(qtd)
                } else {
                    this.setQuantity(Number(this.quantity) - qtdSobra)
                }
            }
        }
    },
    watch: {
        minimumQuantity(val) {
            this.setQuantity(val)
            this.$emit('quantity', val)
        },
        quantity(value) {
            if(this?.item?.quantity_per_box && this.conversionUnitWhenSellingWithClosedBox == 'CX') {
                this.setNumberOfBoxesSelected(value)
            }
            this.$emit('quantity', value)
        }
    },
    computed: {
        ...mapState("company", [
            "socials",
            "facebookPixel",
            "googleAds"
        ]),
        ...mapState("products", [
            "minimumQuantity",
            "conversionUnitWhenSellingWithClosedBox",
            "quantity",
            "flavors",
            "bkpProduct"
        ]),
        ...mapGetters("products", ["isProductUnavailable"]),
        textWhatsapp() {
            if(!this.socials[4]?.link) {
                return null
            }
            let text = "Olá, tenho interesse no produto "+this.item.pro_name_site+"."
            return this.socials[4].link+"&text="+text
        },
        hidePrice() {
            let hide = this.company?.settings?.hide_price_not_logged_user ?? false
            return ( hide === false ) ? false : ( hide === true && this.isLogged === false ? true : false )
        },
        isLogged() {
            return this.$root.$children[0].$attrs.logged
        },
        isBudgetLayout() {
            return this.$root.$children[0].theme?.is_budget_layout ?? false
        },
        purchaseButtonProductPage() {
            return this.$root.$children[0].theme?.products?.button?.purchase_button_product_page ?? true
        },
        buttonWhatsapp() {
            return this.$root.$children[0].theme?.products?.button_whatsapp?.active_button_whatsapp ?? false
        },
    }
}
</script>

<style scoped>
    .checked {
        color:tomato;
    }
    .purchase {
        font-family: "Oswald",sans-serif;
        font-weight: 400;
        text-transform: uppercase;
        padding: .85rem .5rem;
        min-width: 115px;
        z-index: 2;
    }
    .purchase span {
        display:block
    }
    .component-actions {
        margin-bottom: unset !important;
    }
    .add-cart::before {
        margin-left: 0.5rem;
        margin-top: 2px;
    }
    .add-cart span {
        margin-left: -0.2rem;
    }
</style>
